import * as React from 'react';
import { SlimOffering } from 'Core/Api/Api';
import { Card } from 'antd';

export interface Props {
  children?: React.ReactNode;
  offering: SlimOffering;
}

export interface State {}

export default class OfferingCard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Card>
        cover ={<img alt="" src={this.props.offering.fileUrl} />}
        <meta title={this.props.offering.title} />
        actions={}
      </Card>
    );
  }
}
